module.exports = __webpack_public_path__ + "static/media/logoCommunity.d466f84c.svg";